module.exports = __webpack_public_path__ + "img/emo_22.f253e791.gif";